//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { DataProvider, OperatorLayoutSettings } from '../../helpers'

import { OpOperator } from '../../models/core'
import { OpOperatorSettings } from '../../models/custom'
import { OperatorLayoutSetting } from '../../models/local'


export interface UserSessionService {

    //#region Logged Operator

    setLoggedOperator(loggedOperator: OpOperator): JQueryPromise<void>
    getLoggedOperator(): OpOperator
    getIdLoggedOperator(): number
    getLoggedOperatorAsync(): JQueryPromise<OpOperator>

    //#endregion


    //#region DataProvider

    setDataProvider(dataProvider: DataProvider)
    getDataProvider(): DataProvider
    getOperatorLayoutSetting<T>(setting: OperatorLayoutSetting, defaultValue?: T): T
    setOperatorLayoutSetting(setting: OperatorLayoutSetting, value: any)
    saveOperatorLayoutSettings(time?, isLogout?, callback?): JQueryPromise<void>

    //#endregion
}

export const USER_SESSION_SERVICE_NAME = 'userSession'
export const USER_SESSION_SERVICE_PROVIDER_NAME = 'userSessionProvider'

export class UserSessionServiceProvider implements ng.IServiceProvider {

    //#region Members

    private _loggedOperator: OpOperator = null
    private _loggedOperatorSettings: OpOperatorSettings = null
    private _loggedOperatorLayoutSettings: OperatorLayoutSettings = null
    private _dataProvider: DataProvider = new DataProvider()

    private deferredLoggedOperator: JQueryDeferred<OpOperator> = $.Deferred<OpOperator>().done(values => { })
    private deferredLoggedOperatorSettings: JQueryDeferred<OpOperatorSettings> = $.Deferred<OpOperatorSettings>().done(values => { })

    //#endregion


    //#region Logged Operator

    public set loggedOperator(loggedOperator: OpOperator) {
        this._loggedOperator = loggedOperator
        this.deferredLoggedOperator.resolve(loggedOperator)
    }

    public get loggedOperator(): OpOperator {
        return this._loggedOperator
    }

    public getLoggedOperatorAsync(): JQueryPromise<OpOperator> {
        return this.deferredLoggedOperator.promise()
    }

    //#endregion


    //#region Operator Settings

    public set loggedOperatorSettings(loggedOperatorSettings: OpOperatorSettings) {
        this._loggedOperatorSettings = loggedOperatorSettings
        this.deferredLoggedOperatorSettings.resolve(loggedOperatorSettings)
    }

    public get loggedOperatorSettings(): OpOperatorSettings {
        return this._loggedOperatorSettings
    }

    public getLoggedOperatorSettingsAsync(): JQueryPromise<OpOperatorSettings> {
        return this.deferredLoggedOperatorSettings.promise()
    }

    //#endregion


    //#region DataProvider

    public set dataProvider(dataProvider: DataProvider) {
        this._dataProvider = dataProvider
    }

    public get dataProvider(): DataProvider {
        return this._dataProvider
    }

    //#endregion


    //#region OperatorLayoutSettings

    public set loggedOperatorLayoutSettings(loggedOperatorLayoutSettings: OperatorLayoutSettings) {
        this._loggedOperatorLayoutSettings = loggedOperatorLayoutSettings
    }

    public get loggedOperatorLayoutSettings(): OperatorLayoutSettings {
        return this._loggedOperatorLayoutSettings
    }

    //#endregion

    public $get(): UserSessionService {

        const userSession: UserSessionService = {
            //loggedOperator
            getLoggedOperator: (): OpOperator => {
                return this.loggedOperator
            },

            getLoggedOperatorAsync: (): JQueryPromise<OpOperator> => {
                return this.getLoggedOperatorAsync()
            },

            getIdLoggedOperator: (): number => {
                if (this.loggedOperator) {
                    return this.loggedOperator.idOperator
                } else {
                    throw new Error('Operator must be logged!')
                }
            },

            setLoggedOperator: (loggedOperator: OpOperator): JQueryPromise<void> => {
                this.loggedOperator = loggedOperator

                return OperatorLayoutSettings
                    .initOperatorLayoutSettings(userSession)
                    .then(operatorLayoutSettings => {
                        if (operatorLayoutSettings) {
                            this.loggedOperatorLayoutSettings = operatorLayoutSettings
                        }
                        else {
                            throw new Error("OperatorLayoutSettings can't be null!")
                        }
                    })
            },

            getDataProvider: (): DataProvider => {
                return this.dataProvider
            },

            setDataProvider: (dataProvider: DataProvider): void => {
                this.dataProvider = dataProvider
            },

            getOperatorLayoutSetting: <T>(setting: OperatorLayoutSetting, defaultValue: T): T => {
                return this.loggedOperatorLayoutSettings.getSetting(setting, defaultValue)
            },

            setOperatorLayoutSetting: (setting: OperatorLayoutSetting, value: any): void => {
                this.loggedOperatorLayoutSettings.setSetting(setting, value)
            },

            saveOperatorLayoutSettings: (time: number = 5000, isLogout = false, callback?): JQueryPromise<void> => {
                return this.loggedOperatorLayoutSettings.saveSettingsToDB(time, isLogout, callback)
            }
        }

        return userSession
    }
}